module.exports = __webpack_public_path__ + "media/Teil 2.cc59c8f8.webm";